import { Flex, Button, Text, Icon } from '@spothero/ui';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import IconTimes from '@spothero/icons/times';
import { setSearchVehiclePopoverVisible } from 'store/search/search-actions';
import { getSearchOversizePopoverVisibleFromSession } from 'utils/search-vehicle';
import { isSomeSpotOversize } from 'store/spots/spots-selectors';
import { SearchWidgetTooltip } from '@spothero/search-component';
// Update this array to include the cities where the oversize popover should be displayed
const OVERSIZE_ENABLED_CITIES = ['nyc'];
export const useVehicleTooltipText = ({ isOversizedEnabled, }) => {
    const dispatch = useDispatch();
    const { slug: citySlug } = useSelector((state) => state.city.data) || {};
    const isAnySearchResultOversize = useSelector(isSomeSpotOversize);
    const { vehicle, searchOversizePopoverVisible } = useSelector((state) => state.search.data);
    const handleClose = () => {
        dispatch(setSearchVehiclePopoverVisible(false));
    };
    // sync the oversize popover visibility with session storage
    useEffect(() => {
        const value = getSearchOversizePopoverVisibleFromSession();
        if (value !== null) {
            dispatch(setSearchVehiclePopoverVisible(value));
        }
    }, [dispatch]);
    if ((vehicle && !isAnySearchResultOversize) ||
        searchOversizePopoverVisible === false ||
        !isOversizedEnabled ||
        !OVERSIZE_ENABLED_CITIES.includes(citySlug)) {
        return { text: null, handleClose };
    }
    const text = isAnySearchResultOversize && vehicle?.display_description
        ? `The ${vehicle?.display_description} may be considered an oversize vehicle at certain facilities, and an oversize fee may apply.`
        : 'Enter your vehicle information to avoid surprise oversize fees.';
    return { text, handleClose };
};
// The Popover components in @spothero/ui were not suitable for our needs because:
// * They are intended to be triggered/attached to other UI elements.
// * They use absolute positioning.
// * They require extensive style overrides.
// As a result, we created this custom component to better meet our UX requirements.
export default function VehiclePopover({ isOversizedEnabled, }) {
    const { text, handleClose } = useVehicleTooltipText({ isOversizedEnabled });
    if (!text)
        return null;
    return (<Flex color="white" backgroundColor="secondary.default" p="4" sx={{
            position: 'relative',
            '::before': {
                content: '""',
                position: 'absolute',
                top: '-19px',
                left: '18%',
                transform: 'translateX(-50%)',
                borderWidth: '10px',
                borderStyle: 'solid',
                borderColor: 'transparent',
                borderBottomColor: 'secondary.default',
            },
        }} justifyContent="space-between" alignItems="center" data-testid="VehiclePopover">
            <Text variant="body2" data-testid="VehiclePopover-message">
                {text}
            </Text>
            <Button variant="tertiary" onClick={handleClose} data-testid="VehiclePopover-close-button">
                <Icon as={IconTimes} width="4" height="4" fill="white"/>
            </Button>
        </Flex>);
}
export const VehicleSearchRevampTooltip = ({ isOversizedEnabled, }) => {
    const { text, handleClose } = useVehicleTooltipText({ isOversizedEnabled });
    if (!text)
        return null;
    return <SearchWidgetTooltip text={text} onClose={handleClose}/>;
};
